//import { Subject } from 'rxjs/Rx';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Component, ViewChild } from '@angular/core';
import { NavController, AlertController, ToastController } from 'ionic-angular';
import { AuthProvider } from '../../providers/auth/auth';

import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';

import { Trip, SelectObj } from '../../models/trip';

import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from 'angularfire2/firestore';

@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})
export class HomePage {
  @ViewChild('gauge') gauge;
  
  currentUser: string

  vehicle$: Observable<SelectObj[]>
  vehicle: SelectObj
  vehicleCollectionRef: AngularFirestoreCollection<SelectObj>
  trips$: Observable<Trip[]>
  showGauge: boolean = false
  isWaitingOnGauge: boolean = false
  isWaitingOnExport: boolean = false

  tot: number = 0
  tot$: Observable<number>
  period$ = new Subject<{start: string, end: string}>()

  gaugeData = {
    chartType: 'Gauge',
    dataTable: [
      ['Label', 'Value'],
      ['Private', 50]
    ],
    options: {
        height: 480,
        redFrom: 90, redTo: 100,
        yellowFrom: 75, yellowTo: 90,
        minorTicks: 5
    },
  };

  constructor(private http: HttpClient, public alertCtrl: AlertController, public toastCtrl: ToastController, public navCtrl: NavController, private afs: AngularFirestore, public authData: AuthProvider) {
    this.vehicleCollectionRef = afs.collection<SelectObj>('vehicles')
  }

  ngOnInit(){
    this.vehicle$ = this.afs.collection<SelectObj>('vehicles').valueChanges()    
  }

  ionViewWillEnter(){
    this.afs.doc<SelectObj>('settings/vehicle').valueChanges().take(1).subscribe(val => {
      this.vehicle = val
    })
  }

  showToast(message: string) {
    let toast = this.toastCtrl.create({
      message: message,
      duration: 1500,
      position: 'middle'
    });
    toast.present(toast);
  }

  setYear(){
    let prompt = this.alertCtrl.create({
      title: 'Set Year',
      message: "Set year for Export",
      inputs: [
        {
          name: 'year',
          placeholder: 'Export Year (YYYY)'
        },
      ],
      buttons: [
        {
          text: 'Cancel',
          handler: data => {
            // console.log('Cancel clicked');
          }
        },
        {
          text: 'Set',
          handler: data => {
            // console.log('Saved clicked');
            this.afs.doc('settings/export').set({year: data.year})
          }
        }
      ]
    });
    prompt.present();  
  }

  sendExport(){
    this.isWaitingOnExport = true
    this.authData.afAuth.idToken.take(1).subscribe(tok => {
        this.http.post('https://us-central1-tripsys2.cloudfunctions.net/mailExport', {tok: tok}).subscribe(data => {
          this.isWaitingOnExport = false
          this.showToast('Export sent by mail')
      },
        (err: HttpErrorResponse) => {
          if (err.error instanceof Error) {
            // A client-side or network error occurred. Handle it accordingly.
            console.log('An error occurred:', err.error.message);
          } else {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong,
            console.log(`Backend returned code ${err.status}, body was: ${err.error}`);
          }
          this.isWaitingOnExport = false
          this.showToast('Could not send Export mail')
        }
      )
    })  
  }

  getGaugeData(){
    this.isWaitingOnGauge = true
    this.showGauge = true
    this.authData.afAuth.idToken.take(1).subscribe(tok => {
        this.http.post('https://us-central1-tripsys2.cloudfunctions.net/gaugeData', {tok: tok}).subscribe(data => {
          let dataTable = this.gauge.wrapper.getDataTable();
          dataTable.setValue(0, 1, data['results'][1]/5)
          this.gauge.redraw()
          this.isWaitingOnGauge = false
      },
        (err: HttpErrorResponse) => {
          if (err.error instanceof Error) {
            // A client-side or network error occurred. Handle it accordingly.
            console.log('An error occurred:', err.error.message);
          } else {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong,
            console.log(`Backend returned code ${err.status}, body was: ${err.error}`);
          }
          this.showToast('Could not get Gauge data')
          this.isWaitingOnGauge = false
          this.showGauge = false
      })  
    })
  }

  addVehicle(){
    let prompt = this.alertCtrl.create({
        title: 'New vehicle',
        message: "Add new vehicle to choose from",
        inputs: [
          {
            name: 'vehicle',
            placeholder: 'Vehicle identifier/license'
          },
        ],
        buttons: [
          {
            text: 'Cancel',
            handler: data => {
              // console.log('Cancel clicked');
            }
          },
          {
            text: 'Add',
            handler: data => {
              // console.log('Saved clicked');
              this.vehicleCollectionRef.add({text: data.vehicle, value:data.vehicle})
            }
          }
        ]
      });
    prompt.present();
  }

  compareFn(option1: any, option2: any){
    return option1.value === option2.value;
  }

  onChangeVehicle(vehicle){
    this.afs.doc<SelectObj>('settings/vehicle').set(vehicle)
  }

  logout(){
    this.authData.logoutUser().then(x => {
      console.log('logout')
    })
  }

}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts